export default __webpack_public_path__ + "static/the_energy_of_joy_2-d0424510369e93843b11d0cff89b7888.png";